import { Diamond } from '@gonfalon/icons/Diamond';
import type { IconProps } from '@launchpad-ui/icons';

import { getVariationFillColor } from '../../../utils/getVariationFillColor';

export type VariationColorProps = {
  variationIndex: number;
  className?: string;
  size?: IconProps['size'];
  overrideColor?: string;
};

export function VariationColor({ variationIndex, className, size = 'small', overrideColor }: VariationColorProps) {
  return <Diamond className={className} size={size} fill={overrideColor ?? getVariationFillColor(variationIndex)} />;
}
